<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 7px;">发布时间</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
        <input-select selectTitle="直播类型" :selectKey="'typeName'" selectWidth="180px" :selectData="typeNameList" @search="search" style="margin-left: 10px;"/>
      </div>
      <input-search placeholder="直播标题" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @lookOver="lookOver" :deleteTipInfo="'是否确认删除直播？'" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" tableOperationWidth="120px"/>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/EnterpriseFavour'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'party-information-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '惠企服务',
        name: 'latest-policy-manage'
      }, {
        value: '亲清直播间'
      }],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      timevalue: [],
      operationArr: ['current'],
      typeNameList: [
        {
          key: '',
          label: '全部'
        }, {
          key: '网红经济',
          label: '网红经济'
        }, {
          key: '政策解读',
          label: '政策解读'
        }, {
          key: '企业码',
          label: '企业码'
        }, {
          key: '所得税',
          label: '所得税'
        }, {
          key: '税收政策',
          label: '税收政策'
        }, {
          key: '制造业',
          label: '制造业'
        }, {
          key: '企业家经验分享',
          label: '企业家经验分享'
        },
      ],
      tableHead: [{
        prop: 'title',
        label: '直播标题'
      }, {
        prop: 'typeName',
        label: '直播类型'
      }, {
        prop: 'startTime',
        label: '直播开始时间'
      }, {
        prop: 'endTime',
        label: '直播结束时间'
      }, {
        prop: 'statusText',
        label: '直播状态'
      }, {
        prop: 'videoLink',
        isLookOver: true,
        label: '直播地址'
      }, {
        prop: 'viewNumber',
        label: '浏览量',
        width: '100'
      }, {
        prop: 'collectNumber',
        label: '收藏量',
        width: '100'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
        startTime: '',
        endTime: '',
      },
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getCreatTime()
  },
  methods: {
    getCreatTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()

      let lastDate = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);//最后30天可以更改，意义：是获取多少天前的时间
      let lastY = lastDate.getFullYear();
      let lastM = (lastDate.getMonth() + 1) < 10 ? '0' + (lastDate.getMonth() + 1) : (lastDate.getMonth() + 1)
      let lastD = lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate()
      this.timevalue[0] = lastY + '-' + lastM + '-' + lastD
      this.timevalue[1] = year + '-' + month + '-' + date
      this.getPage()
    },
    getPage () {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || ''
        this.requestData.endTime = this.timevalue[1] || ''
      } else {
        this.requestData.startTime = ''
        this.requestData.endTime = ''
      }
      this.$axios.post(api.getLivePage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              if (v.status === '0') {
                v.statusText = '预告中'
              } else if (v.status === '1') {
                v.statusText = '直播中'
              } else if (v.status === '2') {
                v.statusText = '已结束'
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取失败'))
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    toCurrentPage (code) {
      this.$router.push({
        path: `/live_room_current/${code}`
      })
    },
    lookOver (data) {
      window.open(data, '_blank')
    }
  },
  watch: {
    timevalue (val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseFavour/LiveRoom/LiveRoomManage.vue